import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClientsService } from '../clients.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { Client } from '../client.interface';
import { InfoClientSidebar } from '../../../../../utils/enum/info-client-sidebar';

@Component({
    selector: 'app-info-client',
    templateUrl: './info-client.component.html',
    styleUrls: ['./info-client.component.scss'],
})
export class InfoClientComponent {

    readonly InfoClientSidebar = InfoClientSidebar;
    selectedComponent: InfoClientSidebar = InfoClientSidebar.GENERAL as InfoClientSidebar;

    componentMapping: Record<InfoClientSidebar, string> = {
        [InfoClientSidebar.GENERAL]: 'app-client-general-info',
        [InfoClientSidebar.CONTACTS]: 'app-client-contacts',
        [InfoClientSidebar.MODULES]: 'app-client-modules',
        [InfoClientSidebar.OPERATORS]: 'app-client-operators',
        [InfoClientSidebar.PERMISSIONS]: 'app-client-permissions'
    };

    componentKeys: string[] = Object.keys(this.componentMapping);

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: Client,
        private dialogRef: MatDialogRef<InfoClientComponent>
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    scrollToTop($event: Event) {
        $event.preventDefault();

        const scrollableContent = document.querySelector('.scrollable-content');
        if (scrollableContent) {
            scrollableContent.scrollTo(0, 0);
        }
    }
}
